import { graphql } from '@/generated/graphql';

export const REPLACE_USER_FCM_TOKEN = graphql(`
  mutation ReplaceUserFCMToken($data: FCMInput!) {
    replaceUserFCMToken(data: $data) {
      applied
    }
  }
`);

export const REMOVE_USER_FCM_TOKEN = graphql(`
  mutation RemoveUserFcmToken($token: String!) {
    removeUserFcmToken(token: $token) {
      applied
    }
  }
`);
